<template>
    <div class="mobile_menu" id="mobile_menu" :class="{'mobile-menu-min-width-sm': !show_name}">
        <div class="bg-img-menu" :class="{'p-2': show_name}">
            <div class="bg-white pointer" @click="toggleShowName" style="padding:5px 10px;max-width:fit-content;margin: auto;border: 1px solid #113b72;border-radius: 5px;" :class="{ 'move-corner' : show_name }">
                <img src="/static/images/new-theme2024/double-chevron-left.svg" class="chev-img" :class="{'chevron-double-left' : show_name}" alt="">
            </div>
            <div id="route_menus" :class="{'side-bar-overflow' : show_name}">
                <div class="menus-dropdown w-100" :class="{'width-max-content' : !show_name}" v-for="(menu, menu_index) in route_menus" :key="menu_index">
                    <div class="pointer d-flex align-items-center fw-500 w-100 mt-4" :class="{'width-max-content justify-content-center' : !show_name}" v-if="!menu.hasOwnProperty('submenus')" @click="changeSelectedRoute(menu_index)">
                        <router-link :class="{'selected-route':menu.route_names.includes($route.name), 'border-50px': !show_name, 'border-5px': show_name}" class="text-decoration-none text-white px-4" :to="menu.route">
                            <img :src="menu.logo.active" v-if="menu.route_names.includes($route.name)" :class="{'mr-2' : show_name}" alt="">
                            <img :src="menu.logo.inactive" v-else :class="{'mr-2' : show_name}" alt="">
                            <span v-if="show_name" :class="{'text-secondary': menu.route_names.includes($route.name)}">{{menu.name}}</span> 
                        </router-link>
                    </div>
                    <div class="mt-4" :class="{'width-max-content hover-show-menu w-100 position-relative menu-item' : !show_name}" v-else>
                        <div class="d-flex align-items-center justify-content-between pointer dropdowns px-4" :class="{'width-max-content' : !show_name, 'selected-route':menu.route_names.includes($route.name) && !show_name, 'm-auto border-50px' : !show_name, 'border-5px': show_name}" 
                            @click="toggleSubMenuNew(menu_index)">
                            <div :class="{'width-max-content' : !show_name}">
                                <img :src="menu.logo.active" v-if="menu.route_names.includes($route.name) && !show_name" :class="{'mr-2' : show_name}" alt="">
                                <img :src="menu.logo.inactive" v-else :class="{'mr-2' : show_name}" alt="">
                                <span class="fw-500" v-if="show_name" :class="menu.route_names.includes($route.name) && !show_name ? 'text-secondary' : 'text-white'">{{menu.name}}</span> 
                            </div>
                            <div class="arrow-left" v-if="!show_name"></div>
                            <i class="icon icon-chevron-down" :class="menu.route_names.includes($route.name) && !show_name ? 'text-secondary' : 'text-white'" v-if="show_name" :id="'chevron-inverse'+menu_index"></i> 
                        </div>
                        <ul class='menus' v-if="!show_name">
                            <div class="hov-menu-header p-3">
                                <img :src="menu.logo.active" class="mr-2" alt="">
                                <span class="fw-500">{{menu.name}}</span> 
                            </div>
                            <!-- <li class='has-submenu'>Dropdown 1 + Sub Menu
                            <ul class='submenu'>
                                <li>Sub Menu</li>
                                <li>Sub Menu 2</li>
                                <li>Sub Menu 3</li>
                            </ul>
                            </li> -->
                            <li class="fw-500 pointer" v-for="(submenu, submenu_index) in menu.submenus" :key="submenu_index">
                                <router-link class="text-decoration-none py-3 px-5" :to="submenu.route">
                                    <span :class="submenu.sub_route_names.includes($route.name)
                                        && (submenu.sub_route_queries.length == 0 || (submenu.sub_route_queries.length != 0 
                                        && submenu.sub_route_queries.map((x) => x.type).includes($route.query.type))) ? 'text-secondary' : ''"
                                    >
                                        {{ submenu.name }}
                                    </span> 
                                </router-link>
                            </li>
                        </ul>
                        <div class="pl-6" :id="'submenu'+menu_index" v-if="show_name && menu.toggle_submenu">
                            <div class="pointer d-flex align-items-center fw-500" :class="{'width-max-content' : !show_name}" v-for="(submenu, submenu_index) in menu.submenus" :key="submenu_index">
                                <Submenus v-if="submenu.hasOwnProperty('submenus') && submenu.submenus.length > 0"
                                    v-bind="{
                                        name: submenu.name,
                                        submenus: submenu.submenus,
                                        show_name: show_name,
                                        menu_index: menu_index+''+submenu_index
                                    }"
                                    @toggleSubMenu="toggleSubMenu"
                                />
                                <router-link :to="submenu.route" v-else :class="{'selected-route selected-route-submenu pl-0 pr-2':
                                        submenu.sub_route_names.includes($route.name)
                                        && show_name
                                        && (submenu.sub_route_queries.length == 0 || (submenu.sub_route_queries.length != 0 && submenu.sub_route_queries.map((x) => x.type).includes($route.query.type)))
                                    }"
                                    class="text-decoration-none text-white d-flex mt-4 align-items-center border-5px">
                                    <i class="icon icon-chevron-right" :class="submenu.sub_route_names.includes($route.name)
                                        && show_name
                                        && (submenu.sub_route_queries.length == 0 || (submenu.sub_route_queries.length != 0 && submenu.sub_route_queries.map((x) => x.type).includes($route.query.type))) ? 'text-secondary' : 'text-white'"></i> 
                                    <span v-if="show_name" :class="submenu.sub_route_names.includes($route.name)
                                        && show_name
                                        && (submenu.sub_route_queries.length == 0 || (submenu.sub_route_queries.length != 0 
                                        && submenu.sub_route_queries.map((x) => x.type).includes($route.query.type))) ? 'text-secondary' : 'text-white'"
                                    >
                                        {{submenu.name}}
                                    </span>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="switch-user-prpfile w-100">
                <hr style="border-top:1px solid #fff;margin: auto 10px;" :class="{'hr-res': show_name}" />
                <div class="d-flex align-items-center" v-if="show_name">
                    <img class="pro_img" :class="{'pro_img_expanded' : show_name}" :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="35" height="35" />
                    <div>
                        <div class="text-white" style="color: #f4f4f4">{{ loggedInUser.full_name }}</div>
                        <div class="text-capitalize text-white fw-600" style="color: #f4f4f4">{{ loggedInUser.user_role }}</div>
                    </div>
                </div>
                <img class="pro_img" v-else :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="35" height="35" />
            </div>
        </div>
    </div>
</template>

<script>
// import { EventBus } from '../eventBus/nav-bar-event';
import VueBus from 'vue-bus';
import Submenus from './Submenus.vue';
export default{
    props: ["route_menus"],
    data(){
        return {
            show_name: false,
            resized_height: 0
        }
    },
    components: {
        Submenus,
        VueBus
    },
    methods:{
        toggleSubMenuNew(index){
    // Loop through all object and set boolean false
            this.route_menus.forEach((data, d_index) => {
                if(index == d_index){
                    if(data.toggle_submenu == true){
                        data.toggle_submenu = false
                    }else{
                        data.toggle_submenu = true
                    }
                }
            });
        },
        changeSelectedRoute(){
            this.route_menus.forEach((data) => {
                if(data.route_names.includes(this.$route.name)){
                    data.toggle_submenu = true
                }else {
                    data.toggle_submenu = false
                }
            });
            this.$emit('changeSelectedRoute', index) 
        },
        changeArchieve(){
            this.$router.push({
                name: "ArchieveListView"
            })
            this.$bus.emit('updateArchieveView')
            // EventBus.$emit('updateArchieveView')
        },
        toggleShowName(){
            this.show_name = !this.show_name
            if(this.show_name){
                this.route_menus.forEach((data, index) => {
                    if(data.route_names.includes(this.$route.name)){
                       data.toggle_submenu = true
                    }
                });
            }else{
                this.route_menus.forEach((data, index) => {
                    data.toggle_submenu = false
                });
            }
            this.$emit('handleToggleShow', this.show_name)
            if(window.innerWidth < 992){
                setTimeout(() => {
                    console.log(document.getElementById('mobile_menu').classList)
                    document.getElementById('mobile_menu').classList.add('mobile_menu_active')
                    console.log(document.getElementById('mobile_menu').classList)
                }, 10);
            }
        },
        toggleSubMenu(menu_number){
            if(this.show_name){
                let submenu = document.getElementById(`submenu${menu_number}`);
                let chevron_inverse = document.getElementById(`chevron-inverse${menu_number}`)
                submenu.classList.toggle('submenu')
                chevron_inverse.classList.toggle('chevron-inverse')
            } 
        },
        resizeWatcher(e) {
            if(window.innerWidth > 992){
                this.resized_height = window.outerHeight - 175
            }
            this.MenuTransition(e)
        },
        MenuTransition(e){
            let mobile_menu = document.getElementById('mobile_menu');
            let events_blocker = document.getElementById('events-blocker')
            if(e.target.innerWidth > 992){
                if(this.show_name) {
                    if(!document.getElementById('content-box').classList.contains("content-boxnew")) document.getElementById('content-box').classList.add("content-boxnew")
                    if(!document.getElementById('nav-right').classList.contains("ml-100px")) document.getElementById('nav-right').classList.add("ml-100px")
                }
                if(mobile_menu.classList.contains('mobile_menu_active')) mobile_menu.classList.toggle('mobile_menu_active')
                if(events_blocker.classList.contains('events_blocker_active')) events_blocker.classList.toggle('events_blocker_active')
                this.$emit('handleToggleShow', false)
            }
            if(e.target.innerWidth < 992){
                this.show_name = false
                this.$emit('handleToggleShow', false)
            }
        }
    },
    computed:{
        loggedInUser(){
            return this.$store.state.store.loggedInUser
        }
    },
    mounted(){
        // EventBus.$on('handleMobileMenu', () => {
        //     let mobile_menu = document.getElementById('mobile_menu');
        //     if(mobile_menu.classList.contains('mobile_menu_active')){
        //         mobile_menu.classList.remove('mobile_menu_active') 
        //         this.show_name = false
        //     } else {
        //         mobile_menu.classList.add('mobile_menu_active')   
        //     }
        // })
        this.$bus.on('handleMobileMenu', () => {
            let mobile_menu = document.getElementById('mobile_menu');
            if(mobile_menu.classList.contains('mobile_menu_active')){
                mobile_menu.classList.remove('mobile_menu_active') 
                this.show_name = false
            } else {
                mobile_menu.classList.add('mobile_menu_active')   
            }
        })
        $('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
            if (!$(this).next().hasClass('show')) {
                $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
            }
            var $subMenu = $(this).next(".dropdown-menu");
            $subMenu.toggleClass('show');

            $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
                $('.dropdown-submenu .show').removeClass("show");
            });
            return false;
        });
        $("a.menu-toggle").click(function() {
            $("#menu-dropdown").dropdown("toggle");
        });

        $(document).ready(function(){
            $(".flexMenu-viewMore").click(function(){
                $(this).find("ul.flexMenu-popup").slideToggle("fast");
            });
        });
        $(document).on("click", function(event){
            var $trigger = $(".flexMenu-viewMore");
            if($trigger !== event.target && !$trigger.has(event.target).length){
                $("ul.flexMenu-popup").slideUp("fast");
            }
        });

        $(".dc-menu-item").on("click", function(event){
            var $trigger = $(".flexMenu-viewMore");
            if($trigger !== event.target && !$trigger.has(event.target).length){
                $("ul.flexMenu-popup").slideUp("fast");
                $("ul.flexMenu-popup").css({"display": "none"});
            }
            $('.flexMenu-viewMore .active').removeClass("active");
            $('.flexMenu-viewMore .active').addClass("active");
            $("ul.flexMenu-popup").css({"display": "none"});
        });
    },
    created(){
        this.resized_height = window.outerHeight - 175
        window.addEventListener('resize', this.resizeWatcher)
    }
}
</script>

<style scoped>
ul{
    list-style-type: none !important;
}
.nav-link>span {
    padding-left: 5px !important;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
    color: #4e4e4e;
}
.m-bottom{
    margin-bottom: 2px;
}
.ham-res{
    display: none;
}
@media screen and (max-width: 992px){
    .show-desktop{
        display: none !important;
    }
    .ham-res{
        display: block;
        position:absolute;
        top:25px;
        left:50px
    }
}
@media screen and (max-width: 900px) {
    .ham-res{
        top:20px;
    }
}
.mobile_menu{
    transition: .3s ease-in-out !important;
    background-color: transparent;
    min-width:210px !important;
    max-width: 500px;
    box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);
    position: fixed;
    z-index: 9;
    top:92px;
    height:100%;
    left: 0;
}
.mobile_menu_active{
    transition: transform .3s ease-in-out!important;
    transform: translateX(0%) !important;
}
.h-0px{
    height: 0px;
    transition: all .5s ease;
}
.submenu{
    height: max-content;
    transition: all .5s ease;
    padding-left: 23px !important;
}
.header-company{
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 0.04em;
}
ul.menus-dropdown{
    overflow-x: hidden !important;
    max-height: 500px !important;
    overflow: scroll;   
    padding: 20px 10px 20px 15px;
}
ul.menus-dropdown li{
    color: #fff !important;
}
ul.menus-dropdown li a{
    padding: 0 9px;
}
.h-35px{
    height: 35px !important
}
.events-blocker{
    position: fixed;
    top: 0px;
    z-index: 99998;
    height: 100%;
    background: rgba(0, 0, 0, 0.5) !important;
    transform: translate(-100%);
}
.events_blocker_active{
    transform: translate(0%);
}
.text-decoration-none{
    text-decoration: none;
}
.text-white{
    color: #fff !important;
}
.icon-chevron-down{
    transition: transform .3s ease-in-out!important;
}
.chevron-inverse{
    transform: rotate(180deg);
}
.chevron-inverse-45deg{
    transform: rotate(180deg);
}
.hrms-logo{
    background-color: #00448b;
    border-radius: 5px;
    padding: 5px;
}
.product-name{
    line-height: 32px;
}
.top-corner-padding{
    padding: 25px 0 0 30px !important;
    margin-bottom: 25px;
}
.selected-route{
    background: #d5e1fa;
    padding: 0 10px 0 10px;
    border-radius: 50px;
    line-height: 30px;
    color: #fff !important
}
.selected-route-submenu{
    width:100%;
}
.selected-route.border-50px{
    border-radius: 50px
}
.selected-route.border-5px{
    border-radius: 5px
}
.menu-item:hover .dropdowns .arrow-left{
    display: block !important;
}
.menu-item:hover .dropdowns + .menus{
    display: block;
}
.fs-17{
    font-size: 17px;
}
.bg-img-menu{
    padding-top: 40px;
    padding: 40px 0;
    height: 100% !important;
    border-top-right-radius:50px;
    background-image: url(/static/images/new-theme2024/sidebar-bg.jpg);
}
.chevron-double-left{
    transform: rotate(180deg);
}
.chev-img{
    transition: all .5s ease;
}
.width-max-content{
    width: max-content !important;
}
.move-corner{
    position: absolute;
    right: -15px;
    top: 52px;
}
.hide {
  display: none;
}

.hov-menu:hover .hide {
  display: block;
}

.hov-menu{
    position: absolute;
    left:100px;
    top: 0px;
    background-color: #fff;
    border-radius:5px;
    border: solid 0.5px #f0ddb7;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
}
.hov-menu-header{
    background-color:#f0ddb7;
    border-radius: 5px 5px 0px 0px;
}
.hide:hover{
    display: block;
}
.hover-show-menu{
    margin: auto;
}
.hover-show-menu:hover .hide {
  display: block;
  color: #363636;
}
.w-100{
    width: 100% !important
}
.m-auto{
    margin: auto !important;
    /* display: block !important; */
}
.position-relative{
    position: relative;
}
.mobile-menu-min-width-sm{
    min-width: 75px !important;
}
.arrow-left{
    display: none;
    width: 0; 
    height: 0; 
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent; 
    border-right:10px solid #fff; 
    position: absolute;
    right: 0px;
}
@media screen and (max-width: 992px) {
    .mobile_menu{
        transform: translate(-100%);
        top: 0px;
        height: 100%;
        z-index: 99999 !important
    }
    .bg-img-menu{
        height: 100% !important;
    }
}
@media screen and (max-width: 768px) {
    .hide-sm-768px{
        display: none !important;
    }   
}

/* Submenu popover */
ul.menus {
    height: auto;
    width: max-content;
    max-width: 220px;
    background: #fff;
    position: absolute;
    top: -30px;
    left: 75px;
    z-index: 99;
    display: none;
    border: 0;
    border-radius: 7px;
    box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 0.5px #f0ddb7;
}

ul.menus li {
    display: block;
    width: 100%;
    text-transform: none;
    text-decoration: none;
    padding: 10px 5px;
    color: #363636;
}

li:hover ul.menus {
    display: block
}
ul.menus a:hover {
    color: #00448b;
}

ul.menus .submenu {
    display: none;
    position: absolute;
    left: 180px;
    background: #fff;
    top: 0;
    width: max-content;
    max-width: 250px;
}

ul.menus .submenu li {
    background: #fff;
}
ul.menus .submenu li a{
    text-decoration: none;
}

ul.menus .has-submenu:hover .submenu {
    display: block;
}
ul,
li {
margin: 0 0;
padding: 0 0;
list-style: none
}

ul {
height: 35px
}

li {
float: left;
display: inline;
position: relative;
text-transform: uppercase
}

li:first-child {
border-left: none
}
.switch-user-prpfile{
    position: absolute;
    bottom:95px;
    /* left: 20px; */
}
.hr-res{
    margin: auto 25px auto 10px !important;
}
.pro_img{
    border-radius: 50%;
    border: 2px solid rgb(236, 241, 249);
    position: relative;
    left: 20px;
    margin: 10px auto;
}
.pro_img_expanded{
    left: 0px !important;
    margin: 10px;
}
@media screen and (max-width:992px) {
    .switch-user-prpfile{
        bottom:0px;
    }
}
.side-bar-overflow{
    height: 70%;
    overflow: auto;
}
</style>